export default __webpack_public_path__ + "static/media/playCircle-default.642d2916.png";